import {
  UI_COLOR_RBAC_ROLE_AUDITOR_BG,
  UI_COLOR_RBAC_ROLE_AUDITOR_TEXT,
  UI_COLOR_RBAC_ROLE_BG,
  UI_COLOR_RBAC_ROLE_COORDINADOR_BG,
  UI_COLOR_RBAC_ROLE_COORDINADOR_TEXT,
  UI_COLOR_RBAC_ROLE_GERENCIA_BG,
  UI_COLOR_RBAC_ROLE_GERENCIA_TEXT,
  UI_COLOR_RBAC_ROLE_PROCESADOR_BG,
  UI_COLOR_RBAC_ROLE_PROCESADOR_TEXT,
  UI_COLOR_RBAC_ROLE_SUPERVISOR_BG,
  UI_COLOR_RBAC_ROLE_SUPERVISOR_TEXT,
  UI_COLOR_RBAC_ROLE_TEXT,
  UI_COLOR_RBAC_ROLE_UNASSIGNED_BG,
  UI_COLOR_RBAC_ROLE_UNASSIGNED_TEXT,
  UI_COLOR_RBAC_STATUS_ACTIVE_BG,
  UI_COLOR_RBAC_STATUS_ACTIVE_TEXT,
  UI_COLOR_RBAC_STATUS_INACTIVE_BG,
  UI_COLOR_RBAC_STATUS_INACTIVE_TEXT,
  UI_COLOR_RBAC_STATUS_PENDING_BG,
  UI_COLOR_RBAC_STATUS_PENDING_TEXT
} from '../../../constants/uiColors'

export const RBAC_STATUS_COLORS = {
  active: {
    background: UI_COLOR_RBAC_STATUS_ACTIVE_BG,
    text: UI_COLOR_RBAC_STATUS_ACTIVE_TEXT
  },
  inactive: {
    background: UI_COLOR_RBAC_STATUS_INACTIVE_BG,
    text: UI_COLOR_RBAC_STATUS_INACTIVE_TEXT
  },
  pending: {
    background: UI_COLOR_RBAC_STATUS_PENDING_BG,
    text: UI_COLOR_RBAC_STATUS_PENDING_TEXT
  }
}

export const RBAC_ROLE_CHIP_COLORS = {
  assigned: {
    background: UI_COLOR_RBAC_ROLE_BG,
    text: UI_COLOR_RBAC_ROLE_TEXT
  },
  unassigned: {
    background: UI_COLOR_RBAC_ROLE_UNASSIGNED_BG,
    text: UI_COLOR_RBAC_ROLE_UNASSIGNED_TEXT
  },
  gerencia: {
    background: UI_COLOR_RBAC_ROLE_GERENCIA_BG,
    text: UI_COLOR_RBAC_ROLE_GERENCIA_TEXT
  },
  supervisor: {
    background: UI_COLOR_RBAC_ROLE_SUPERVISOR_BG,
    text: UI_COLOR_RBAC_ROLE_SUPERVISOR_TEXT
  },
  procesador: {
    background: UI_COLOR_RBAC_ROLE_PROCESADOR_BG,
    text: UI_COLOR_RBAC_ROLE_PROCESADOR_TEXT
  },
  coordinador: {
    background: UI_COLOR_RBAC_ROLE_COORDINADOR_BG,
    text: UI_COLOR_RBAC_ROLE_COORDINADOR_TEXT
  },
  auditor: {
    background: UI_COLOR_RBAC_ROLE_AUDITOR_BG,
    text: UI_COLOR_RBAC_ROLE_AUDITOR_TEXT
  }
}
